import React, { useEffect, useState } from 'react';
import CookieConsent from 'react-cookie-consent';
import { StyledButton } from '../styles';
import { cookiesBannerData, getCookieFromDict } from './CookieBanner.settings';
import { CookieBannerLine } from './CookieBannerLine';
import { Cookie } from './CookieBanner.styles';
import Link from 'next/link'
import { getCookies, getCookie, setCookies, deleteCookie } from 'cookies-next';
import CookieBannerBottom from './CookieBannerBottom';
import { applyAnalytic } from './CookieBanner.applyAnalytic';
import { withRouter } from 'next/router';

const CookieBanner = ({ show, onClose, router }) => {

  const [showBanner, setShowBanner] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const { pathname } = router;

  const [settings, setSettings] = useState({
    performance: true,
    targeting: true,
    functionality: true,
  })

  useEffect(() => {
    if (show) {
      setShowBanner(true)
      setShowSettings(true);
    } else {
      setShowSettings(false);
      setShowBanner(false);
    }
  }, [show])

  const allAccepted = {
    performance: true,
    targeting: true,
    functionality: true,
  }

  const allRejected = {
    performance: false,
    targeting: false,
    functionality: false,
  }

  const consentCategories = {
    performance: 'performanceCookies',
    targeting: 'targetingCookies',
    functionality: 'functionalityCookies',
  }

  const removeCookiesByType = (type) => {
    const cookieList = cookiesBannerData[type]?.cookieList ?? [];
    cookieList.forEach(el => {
      deleteCookie(el.cookie, { path: '/', domain: el.domain })
    })
  }

  const applyConsent = (consentData) => {
    setSettings(consentData)
    setCookies('cookiesConsent', JSON.stringify(consentData), {
      expires: new Date(Date.now() + 180 * 24 * 60 * 60 * 1000),
      path: '/',
    })
    Object.entries(consentCategories).forEach(([key, bannerKey]) => {
      if (!consentData[key]) {
        removeCookiesByType(bannerKey)
      }
    })
    setShowSettings(false)
    setShowBanner(false)
    if (onClose) {
      onClose()
    }
    if (consentData.performance) {
      applyAnalytic()
    }
  }

  const handleAcceptAll = () => {
    applyConsent(allAccepted)
  }

  const handleCancelAll = () => {
    applyConsent(allRejected)
  } 

  useEffect(() => {
    const consentData = getCookie('cookiesConsent');
    const data = consentData ? JSON.parse(consentData) : undefined;
    const { performance, targeting, functionality } = data ?? {};
    if (performance) {
      applyAnalytic()
    }
    if (pathname === '/cookie-policy') {
      setShowBanner(false);
      setShowSettings(false);
      return;
    }
    if (!data) {
      setShowBanner(true);
    } else {
      setSettings({
        performance,
        targeting,
        functionality,
      })
      setShowBanner(false);
    }
  }, [pathname])

  const handleAccept = () => {
    applyConsent(settings)
  };

  const onCancel = () => {
    applyConsent(allRejected)
  }

  return (
    <>
    <CookieBannerBottom 
      visible={showBanner && !showSettings}
      showSettings={() => setShowSettings(true)}
      onOk={handleAccept}
      onCancel={onCancel}
      id="modal-cookie"
    />
    <CookieConsent
      vibible={showSettings ? 'show' : 'hidden'}
      location="bottom"
      buttonWrapperClasses="cookie-banner-buttons"
      contentClasses="cookie-banner-content"
      containerClasses="cookie-banner-container"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        background: 'rgba(25, 29, 52, 0.7)',
        display: showSettings ? 'flex' : 'none',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '10vw',
      }}
      ButtonComponent={() => (
        <Cookie.Container style={{ paddingTop: 15 }}>
          <Cookie.ButtonsWrapper justifyContent="space-between" gap={20}>
            <Cookie.TopButtons gap={20}>
              <StyledButton 
                style={{ height: '100%', padding: '10px 15px', borderRadius: 20 }}
                light
                onClick={handleAcceptAll}
                className="cookies-consent-button">
                  Accept all
              </StyledButton>
              <StyledButton
                style={{ height: '100%', padding: '10px 15px', borderRadius: 20 }}
                light
                onClick={handleCancelAll}
                className="cookies-consent-button">
                  Reject all
              </StyledButton>
              <StyledButton
                style={{ height: '100%', padding: '10px 15px', borderRadius: 20 }}
                onClick={handleAccept}
                className="cookies-consent-button">
                  Save and close
                </StyledButton>
            </Cookie.TopButtons>

          </Cookie.ButtonsWrapper>
        </Cookie.Container>
      )
      }
      onAccept={handleAccept}
    >
      <Cookie.Container>
        <button className="modal__close" style={{ opacity: 1 }} onClick={() => {
          setShowSettings(false);
          if (onClose) {
            onClose();
          }
        }} />
        <Cookie.FlexCol gap={15}>
          <Cookie.Title>Cookie Policy</Cookie.Title>
          <Cookie.Text>
            Our website uses cookies to improve user experience, collect statistics, and
            present personalized recommendations. By clicking "Accept," you consent to the processing of cookies
            in accordance with
            <Link style={{ color: '#1B48B1', marginLeft: '1em' }} href={'/cookie-policy'} target="_blank">
              <Cookie.Link>Cookie Policy</Cookie.Link>
            </Link>
          </Cookie.Text>
          {Object.values(cookiesBannerData).map(({ key, title, text }) => (
            <CookieBannerLine
              key={key}
              title={title}
              settings={settings}
              cookieType={key}
              text={text}
              setSettings={setSettings}
            />
          ))}
        </Cookie.FlexCol>
      </Cookie.Container>
    </CookieConsent>
    </>
  );
};


export default withRouter(CookieBanner);